import { render } from "./WalletHistory.vue?vue&type=template&id=2d78dcba&scoped=true"
import script from "./WalletHistory.vue?vue&type=script&lang=js"
export * from "./WalletHistory.vue?vue&type=script&lang=js"

import "./WalletHistory.vue?vue&type=style&index=0&id=2d78dcba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d78dcba"]])

export default __exports__